import axios from 'axios';

// Общий клиент для работы с backend API
const apiClient = axios.create({
  baseURL: 'https://api.dudu-shopping.ru:3001/api'
});

export const getCategories = () => apiClient.get('/categories');
export const getCategoryInfo = (categoryId) => apiClient.get(`/category/${categoryId}/info`);
export const getCategoryProducts = (categoryId) => apiClient.get(`/category/${categoryId}`);
export const getCategoryFilters = (categoryId) => apiClient.get(`/category/${categoryId}/filters`);

export const getProductByUrl = (productUrl) =>
  apiClient.get('/product', { params: { url: productUrl } });

export const getProductById = (productId) => apiClient.get(`/product/${productId}`);

export const searchProducts = (params) => apiClient.get('/search', { params });

export const getViewedProducts = (productIds) =>
  apiClient.post('/viewed-products', { productIds });

export const getCartProducts = ({ productIds, countryCode }) =>
  apiClient.post('/cart-products', { productIds, countryCode });

export default apiClient;
